<style scoped>
  .margin-bottom {
    margin-bottom: 0px;
  }
  .parent-item {
   color: #999;
  }
  .child-item {
    margin-left: 10px;
  }
</style>
<template>
  <div>
    <SearchBar 
      ref="search"
      v-model="params"
      :fields="searchFields"
    >
      <template v-slot:status>
        <v-autocomplete
          v-model="params.status"
          :items="status_list_proxy"
          clearable
          item-text="label_s"
          item-value="key"
          label="付款状态"
          :item-disabled="i=>i.is_parent"
          @change="proxyGetData('status')"
        >
          <template v-slot:item="{item}">
            <div
              :class="{
                'child-item':item.is_child,
                'parent-item': item.is_parent
              }"
            >
              {{ item.label }}
            </div>
            <!-- <div>{{ item.label }}</div> -->
          </template>
        </v-autocomplete>
      </template>
      <template v-slot:selected_items>
        <div v-if="get_total">
          <p class="margin-bottom">
            总笔数： {{ get_total.items.length }}<span><v-btn
              x-small
              text
              fab
              color="primary"
              @click="showSelect"
            >
              <v-icon dark>mdi-clipboard-list-outline</v-icon>
            </v-btn></span>
          </p>
          <p class="margin-bottom">
            总金额：{{ get_total.total }}
          </p>
        </div>
      </template>
    </SearchBar>
    <div class="line text-center">
      <!-- <Select
        v-model="params.status"
        placeholder="请选择付款状态"
        style="width: 200px"
        @on-change="statusChange"
      >
        <OptionGroup label="公共状态">
          <Option value="all">
            所有付款状态
          </Option>
          <Option value="submit">
            已提交
          </Option>
          <Option
            value="success"
            class="color-success"
          >
            打款成功
          </Option>
          <Option value="others">
            非提交或成功状态
          </Option>
        </OptionGroup>
        <OptionGroup label="云账户状态">
          <Option
            value="valid_fail"
            class="color-error"
          >
            打款失败(校验不通过)
          </Option>
          <Option
            value="manual_pending"
            class="color-warning"
          >
            待打款(未签约/余额不足等)
          </Option>
          <Option value="paying">
            付款中(无需处理)
          </Option>
          <Option value="pending">
            等待中(无需处理)
          </Option>
          <Option
            value="pay_fail"
            class="color-warning"
          >
            打款失败(支付被退回)
          </Option>
          <Option
            value="cancel"
            class="color-warning"
          >
            打款失败(取消支付)
          </Option>
          <Option
            value="unknown"
            class="color-error"
          >
            未知状态
          </Option>
        </OptionGroup>
        <OptionGroup label="CBS状态 ">
          <Option value="AC">
            中心手工录入后需人工复核
          </Option>
          <Option value="AD">
            待预处理
          </Option>
          <Option value="AE">
            审批否决
          </Option>
          <Option value="AF">
            确认支付失败
          </Option>
          <Option value="AM">
            待审批
          </Option>
          <Option value="AN">
            待支付重发审批
          </Option>
          <Option value="AQ">
            业务撤消
          </Option>
          <Option value="AW">
            待企业审批
          </Option>
          <Option value="BE">
            支付信息有误
          </Option>
          <Option value="BF">
            银行支付失败
          </Option>
          <Option value="BP">
            直联支付中
          </Option>
          <Option value="BQ">
            状态可疑
          </Option>
          <Option value="BR">
            银行退票
          </Option>
          <Option value="BT">
            已提交直联接口进行支付
          </Option>
          <Option value="BW">
            待银行答复
          </Option>
          <Option value="CC">
            客户处理中
          </Option>
          <Option value="CD">
            客户撤消
          </Option>
          <Option value="CF">
            客户审批否决
          </Option>
          <Option value="CL">
            已取消支付
          </Option>
          <Option value="CP">
            待中心处理
          </Option>
          <Option value="DB">
            部分成功
          </Option>
          <Option value="EP">
            待银保通支付
          </Option>
          <Option value="ET">
            银保通支付中
          </Option>
          <Option value="GC">
            分公司取消
          </Option>
          <Option value="GD">
            部分成功
          </Option>
          <Option value="GF">
            文件导出
          </Option>
          <Option value="GQ">
            中意可疑状态
          </Option>
          <Option value="MC">
            待人工确认
          </Option>
          <Option value="OD">
            过期
          </Option>
          <Option value="PP">
            待票据打印
          </Option>
          <Option value="RW">
            等待刷新
          </Option>
        </OptionGroup>
      </Select> -->
      <space />
      <Ajaxbtn
        v-show="false"
        ref="searchBtn"
        :url="get_records_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
        @finally="handleFinally"
      />
    </div>
    <div class="line">
      <Table
        ref="table"
        size="small"
        :columns="columns"
        :data="records"
        :loading="loading"
        @on-selection-change="selectItem"
      />
    </div>
    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
  </div>
</template>
<script route="/payment/records">
  import SearchBar from '@/vuetify_custom/v-form'
  import { CreateStatusList } from './fields'
  const c_status_list = CreateStatusList().map(item => {
    item.label_s = item.children.map(i => i.label).join('-') + '-' + item.label
    item.children.forEach(i => i.label_s = i.label)
    return item
  })
  export default {
    components: {
      SearchBar,
    },
    /* router_info_start */
    router_info: '/payment/records',
    /* router_info_end */
    data() {
      return {
        get_records_path: this.$util.api.query_expense_payment_records,
        loading: false,
        select_items: [],
        params: {
          status: null,
          page: 1,
          per_page: 20,
          end_at: null,
          start_at: null,
          search_key: null,
          platform: null,
          date_range: [],
        },
        page_info:{
          current: 1,
          total: 0,
          page_size: 20
        },
        records: [],
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '付款平台',
            key: 'payment_platform',
            align: 'center',
          },
          {
            title: '平台单号',
            key: 'ref_id',
            align: 'center',
          },
          {
            title: '订单号',
            key: 'order_id',
            align: 'center',
            width: 130,
          },
          {
            title: '付款类型',
            key: 'pay_type',
            align: 'center',
          },
          {
            title: '付款币别',
            key: 'currency',
            align: 'center',
          },
          {
            title: '账户',
            key: 'account',
            align: 'center',
          },
          {
            title: '卡号',
            key: 'card_no',
            align: 'center',
          },
          {
            title: '金额',
            key: 'price',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.price));
            }
          },
          {
            title: '手续费',
            key: 'fee',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.fee));
            }
          },
          {
            title: '状态',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('span', {
                'class': {
                  'color-success': row.status === 'success',
                }
              }, row.status);
            }
          },
          {
            title: '状态信息',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              if (row.status === 'success') {
                return h('span', '-');
              }
              return h('div', row.err_msg);
            }
          },
          {
            title: '提交时间',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const row = params.row;
              return h('div', this.$util.formatTime(row.created_at));
            }
          },
          {
            title: '付款时间',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const row = params.row;
              return h('div', row.paid_at ? this.$util.formatTime(row.paid_at) : '-');
            }
          },
        ]
      }
    },
    computed: {
      // params_proxy() {
      //   const {date_range, ...other} = this.params
      //   return this.params
      // },
      status_list_proxy() {
        let status_list = c_status_list
        if (this.params.platform === 'cbs') {
          status_list = status_list.filter(({key}) => key === 'public_status' || key === 'cbs')
        }
        if (this.params.platform === 'yzh') {
          status_list = status_list.filter(({key}) => key === 'public_status' || key === 'yzh')
        }
        const _status_list = status_list.reduce((total, item) => {
          const children = item.children.map(i => ({
            ...i,
            is_child: true
          }))
          return total.concat([{...item }, ...children])
        }, [])
        return _status_list
      },
      public_status_child_hash() {
        const status_one = c_status_list.filter(({key}) => key === 'public_status')[0]
        return status_one.children.reduce((t, i) => {
          t[i.key] = i
          return t
        }, {})
      },
      get_total() {

        // if (!this.table_ref) {
        //   return null
        // }
        let total = null
        const items = this.select_items
        if (!items || !items.length) {
          return null
        }
        // const tableData = this.table_ref.objData
        items.forEach(item => {
          total = math.eval(`${total}+${item.price}`)
          total = total.toFixed(2)
         
        })
        return {
          total,
          items
        }
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      searchFields() {
        const proxyGetData = this.proxyGetData
        return [
          {
            label: '付款平台',
            type: 'autocompletes',
            key: 'platform',
            cols: 2,
            items: [
              {
                label: 'CBS',
                value: 'cbs'
              },
              {
                label: '云账户',
                value: 'yzh'
              }
            ],
            'item-value':'value',
            'item-text': 'label',
            // 'item-text':(b) => {
            //   let text = `${b.bank_number}-${b.account}-${b.bank}`;
            //   if (b.del) {
            //     text += ' (已弃用)';
            //   }
            //   return text;
            // },
            clearable:true,
            change:() => proxyGetData('platform'),
            'click:clear': () => proxyGetData('platform'),
          },
          {
            label: '付款状态',
            key: 'status',
            cols: 3,
          },
          {
            label: '合同起止时间',
            key:'date_range',
            start_key: 'start_at',
            end_key: 'end_at',
            type:'date_range',
            cols: 2,
            prependIcon: '',
            clearable:true,
            inputTwo:() => {
              proxyGetData('date_range')
            },
            'click:clear': () => proxyGetData('date_range'),
          },
          {
            label: '搜索',
            key: 'search_key',
            cols: 3,
            clearable:true,
            // change: proxyGetData,
            'click:append': () => proxyGetData('search_key'),
            'append-icon': 'mdi-card-search',
            'click:clear':() => proxyGetData('search_key'),
          },
          {
            label: '',
            key: 'selected_items',
            cols: 4,
          }
        ]
      }
    },
    created() {
      //
    },
    mounted() {
      this.doSearch();
    },
    methods: {
      proxyGetData(type) {
        const {start_at, end_at} = this.params
        this.params.date_range = [start_at, end_at].filter(i => !!i)
        if (type === 'platform' && !this.public_status_child_hash[this.params.status]) {
          this.params.status = null
        }
        if (this.params.date_range.length === 1) {
          this.$Message.error('请选择时间段！')
          return
        }
        this.doSearch()
      },
      invertSelectItem() {
        if (!this.select_items || !this.select_items.length || !this.$refs.table) {
          return 
        }
        const select_items_hash = this.select_items.reduce((t, i) => {
          t[i.id] = i
          return t
        }, {})
        const objData = this.$refs.table.objData
        Object.values(objData).forEach(v => {
          if (select_items_hash[v.id]) {
            v._isChecked = true
          }
        })
      },
      selectItem() {
        const select_items_hash = this.select_items.reduce((t, i) => {
          t[i.id] = i
          return t
        }, {})
        const select_items = []
        const objData = this.$refs.table.objData
        Object.values(objData).forEach(v => {
          if (v._isChecked && !select_items_hash[v.id]) {
            select_items.push(v)
          } else if (!v._isChecked && select_items_hash[v.id]) {
            select_items_hash[v.id] = null
          }
        })
        Object.values(select_items_hash).forEach(v => {
          if (v) {
            select_items.push(v)
          } 
        })
        this.select_items = select_items
      },
      showSelect() {
        this.$vModal.info({
          title: '单据',
          content:this.get_total && this.get_total.items.map(i => i.order_id).join('、')
        })
      },
      statusChange() {
        this.params.page = 1;
        this.doSearch();
      },
      beforeSearch() {
        this.loading = true;
      },
      doSearch() {
        this.$refs.searchBtn.doAjax();
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.doSearch();
      },
      handleData(data) {
        this.records = data.records;
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.$Modal.warning({title: '提示', content: e.message});
      },
      handleFinally() {
        this.loading = false;
        this.$nextTick(() => {
          this.invertSelectItem()
        })
      },
      test() {
        Util.ajax.get('api_url', {
          params: {
            //
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            //成功
          } else {
            //失败
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          // always executed
        });
      }
    }
  }
</script>
